var map = {
	"./alexander.png": 1015,
	"./capes.png": 2497,
	"./ciag.png": 8125,
	"./ciag_2.png": 4494,
	"./cnpq.png": 5331,
	"./confianca.png": 9735,
	"./cpfl.png": 3662,
	"./dataguvi.png": 8654,
	"./einstein.png": 1158,
	"./eldorado.png": 5265,
	"./fapesp.png": 5254,
	"./fepaf.png": 7761,
	"./fundeb.png": 8313,
	"./fundunesp.png": 7961,
	"./itau.png": 9616,
	"./movement.png": 5294,
	"./petrobras.png": 608,
	"./red_hat.png": 4030,
	"./unimed.png": 5997,
	"./weduu.png": 6867,
	"./xbri.png": 1748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8629;